import {
  Dialog,
  Box,
  Stack,
  IconButton,
  Typography,
  DialogProps,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';



export type BasicFormModalLayoutProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
  headerIcon?: ReactNode;
  title?: string;
  subTitle?: string;
  children: ReactNode;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: BasicFormModalLayoutProps & Partial<DialogProps>) => {
  const theme = useTheme();
  return (
    <Dialog
      open={props.isVisible}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onClose={() => props.handleClose()}
      fullScreen={props.fullScreen ?? false}
    >
      <Box
        minWidth='22rem'
        display='flex'
        flexDirection='column'
        rowGap='1.5rem'
        height='inherit'
      >

        {/* DIALOG HEADER NO TEXT */}
        <Stack
          paddingTop='1.25rem'
          direction='row'
          justifyContent={props.headerIcon ? 'space-between' : 'flex-end'}
          alignItems='start'
          columnGap='1.25rem'
        >
          <Stack
            columnGap='1rem'
            direction='row'
          >

            {props.headerIcon && (
              <Box
                display='flex'
                flexDirection='row'
                alignItems='center'
                justifyContent='center'
                borderRadius='.75rem'
                border={`1px solid ${theme.palette.secondary.dark}`}
                width='3rem'
                height='3rem'
              >
                {props.headerIcon}
              </Box>
            )}
            <Stack>
              {props.title && (
                <Typography
                  variant='modalTitle'
                >
                  {props.title}
                </Typography>
              )}
              {props.subTitle && (

                <Typography
                  variant='modalSubTitle'
                >
                  {/* Are you sure you want to remove this task? This action cannot be undone. */}
                  {props.subTitle}
                </Typography>
              )}
            </Stack>
          </Stack>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              props.handleClose();
            }}
          >
            <CustomIcon.large.FC
              icon='CLOSE'
            />
          </IconButton>
        </Stack>
        {/* FORM */}
        <Box
          height='100%'
        >
          {props.children}
        </Box>
      </Box>
    </Dialog>
  );
};
